import { BaseAction } from './base.action';
import { InvitationService, NotificationService } from '../../services';
import { CloseReason } from '../../models/close-reason.model';

export class CloseInvitationAction extends BaseAction {
    isChatOpened: boolean;

    constructor(
        private invitationService: InvitationService,
        private notificationService: NotificationService
    ) {
        super();

        // Subscribe to chat state notifications.
        this.notificationService.chatState$.subscribe(
            (isChatOpen) => {
                this.isChatOpened = isChatOpen;
            }
        );
    }

    act(): void {
        if (this.isChatOpened) {
            console.log('No invitation auto close, as invitation was already closed.');
        } else {
            console.log('Automatic invitation close.');
            this.invitationService.hideInvitation(CloseReason.Auto);
        }
    }
}
